import React from 'react';
import { Input, Button } from '@deeptrue-frontend/ui';
import { compose } from 'ramda';
import { FormatMessage } from 'components/IntlProvider/hooks/hooks';
import { Formik, Field as FormikField } from 'formik';
import * as Yup from 'yup';

import IntlProvider, { useFormatMessage } from 'components/IntlProvider';

export interface ForgotPasswordValuesTypes {
  [key: string]: string;
}

const getValidationSchema = (t: FormatMessage) =>
  Yup.object().shape<any>({
    email: Yup.string()
      .email(t('errors.fields.email.format', 'Invalid email format'))
      .required(t('errors.fields.required', 'Field is required')),
  });

interface ForgotPasswordPropos {
  onSubmit: (val: any) => void;
  initialValues: {
    email: string;
  };
}

const ForgotPassword = ({ onSubmit, initialValues }: ForgotPasswordPropos) => {
  const t = useFormatMessage();

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={getValidationSchema(t)}
    >
      {({ handleSubmit, errors, touched, isSubmitting }) => {
        return (
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <FormikField
              name="email"
              as={Input}
              hasError={touched.email && errors.email}
              helperText={touched.email && errors.email}
              label={t('forms.forgotpassword.email', 'Email Address')}
            />
            <Button
              mt="1rem"
              width="100%"
              disabled={isSubmitting}
              isLoading={isSubmitting}
              type="submit"
            >
              {t('forms.forgotpassword.recover', ' Recover password')}
            </Button>
          </form>
        );
      }}
    </Formik>
  );
};

export default compose(IntlProvider.withIntl)(ForgotPassword);
